<template lang="pug">
section.opensite-sec
  .max-container
    .opetitle-wrap
      .arrow-title-img
        img(src='/assets/img/newwebsite/title-arrow-left.png')
      .optitle-box
        .optitle {{ $t('ui.createOperatorAccount') }}
        .optitle-shadow {{ $t('ui.createOperatorAccount') }}
      .arrow-title-img
        img(src='/assets/img/newwebsite/title-arrow-right.png')

    form.login-form.border-bottom-0(novalidate @submit.prevent="submit" :disabled="loading")
      template(v-if="wLList.length > 1")
        .operator-account-wrapper
          .fwrap
            h6.text-muted(style="margin-bottom: 4px;") {{ $t('ui.white_label') }}
            b-form-select(v-model="operatorWhiteLabel" :disabled="loading" style="height: 42px;")
              option(v-for="info in wLList" :value="info") {{ info }}
            ValidateResult(:value="$v.operatorWhiteLabel" :name="$t('ui.white_label')")
        div.my-4(style="border: 1px solid rgb(235 226 226);width:600px;margin:0 auto")
      .operator-account-wrapper
        .fwrap
          b-input-group
            b-input-group-text.text-primary(slot="prepend")
              i.fas.fa-user
            DebounceInput(
              required
              ref="operatorId"
              autofocus
              type="text"
              v-model.trim.lazy="$v.operatorId.$model"
              :placeholder='$t("ui.operatorId")'
              :disabled="loading"
              :maxLength="$v.operatorId.$params.maxLength.max"
              :dirty="$v.operatorId.$dirty"
              :error="$v.operatorId.$error"
              )
          ValidateResult(:value="$v.operatorId" :name="$t('ui.operatorId')")
        .fwrap
          b-input-group
            b-input-group-text.text-primary(slot="prepend")
              i.fas.fa-lock
            DebounceInput(
              required
              autocomplete="section-red current-password"
              :type=" (isPWShown) ? 'password' : 'text'"
              v-model.trim.lazy="$v.operatorPwd.$model"
              :placeholder='$t("ui.operatorPwd")'
              :disabled="loading"
              :maxLength="$v.operatorPwd.$params.maxLength.max"
              :dirty="$v.operatorPwd.$dirty"
              :error="$v.operatorPwd.$error"
            )
            .input-group-append
              b-button(:pressed.sync="isPWShown" style="box-shadow:none;")
                i.fa(:class=" (isPWShown) ? 'icon-eye-open fa-eye' : 'icon-eye-close fa-eye-slash'")
          ValidateResult(:value="$v.operatorPwd" :name="$t('ui.operatorPwd')")
        .pck-btn-wrap
          b-button.btn.btn-primary.pcknext-btn(@click="submit" type="submit" :disabled="loading")
            | {{ $t('ui.create') }}
    //- .operator-account-wrapper
    //-   div
    //-     form.login-form.border-bottom-0(novalidate @submit.prevent="submit" :disabled="loading")
    //-       .fwrap
    //-         b-input-group
    //-           b-input-group-text.text-primary(slot="prepend")
    //-             i.fas.fa-user
    //-           DebounceInput(
    //-             required
    //-             ref="operatorId"
    //-             autofocus
    //-             type="text"
    //-             v-model.trim.lazy="$v.operatorId.$model"
    //-             :placeholder='$t("ui.operatorId")'
    //-             :disabled="loading"
    //-             :maxLength="$v.operatorId.$params.maxLength.max"
    //-             :dirty="$v.operatorId.$dirty"
    //-             :error="$v.operatorId.$error"
    //-             )
    //-         ValidateResult(:value="$v.operatorId" :name="$t('ui.operatorId')")
    //-       .fwrap
    //-         b-input-group
    //-           b-input-group-text.text-primary(slot="prepend")
    //-             i.fas.fa-lock
    //-           DebounceInput(
    //-             required
    //-             autocomplete="section-red current-password"
    //-             :type=" (isPWShown) ? 'password' : 'text'"
    //-             v-model.trim.lazy="$v.operatorPwd.$model"
    //-             :placeholder='$t("ui.operatorPwd")'
    //-             :disabled="loading"
    //-             :maxLength="$v.operatorPwd.$params.maxLength.max"
    //-             :dirty="$v.operatorPwd.$dirty"
    //-             :error="$v.operatorPwd.$error"
    //-           )
    //-           .input-group-append
    //-             b-button(:pressed.sync="isPWShown" style="box-shadow:none;")
    //-               i.fa(:class=" (isPWShown) ? 'icon-eye-open fa-eye' : 'icon-eye-close fa-eye-slash'")
    //-         ValidateResult(:value="$v.operatorPwd" :name="$t('ui.operatorPwd')")
    //-       //- div.mt-4.mb-3(style="border: 1px solid rgb(235 226 226);")
    //-       //- .fwrap(v-if="wLList.length > 1")
    //-       //-   h6.text-muted(style="margin-bottom: 4px;") {{ $t('ui.white_label') }}
    //-       //-   b-form-select(v-model="operatorWhiteLabel" :disabled="loading" style="height: 42px;")
    //-       //-     option(v-for="info in wLList" :value="info") {{ info }}
    //- div.mt-4.mb-3(style="border: 1px solid rgb(235 226 226);width:600px;margin:0 auto")
    //- .operator-account-wrapper
    //-   .fwrap(v-if="wLList.length > 1")
    //-     h6.text-muted(style="margin-bottom: 4px;") {{ $t('ui.white_label') }}
    //-     b-form-select(v-model="operatorWhiteLabel" :disabled="loading" style="height: 42px;")
    //-       option(v-for="info in wLList" :value="info") {{ info }}
    //-     ValidateResult(:value="$v.operatorWhiteLabel" :name="$t('ui.white_label')")
    //-   .pck-btn-wrap
    //-     b-button.btn.btn-primary.pcknext-btn(@click="submit" type="submit" :disabled="loading")
    //-       | {{ $t('ui.create') }}
</template>

<script>
import errorTags from "@/errorTags";
import config from "@/config";
import ValidateResult from "@/library/ValidateResult";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import DebounceInput from "@/library/DebounceInput";
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    ValidateResult,
    DebounceInput,
    SubmitButton
  },
  props: {
    cartId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      operatorId: "",
      operatorPwd: "",
      isPWShown: true,
      wLList: ['ROCKET'],
      operatorWhiteLabel: "ROCKET"
    }
  },
  validations: {
    operatorId: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20),
      mustHaveBothAlphaNumOnly: function(value) {
        const containsAlphabet = /[A-Za-z]/.test(value);
        const containsNumber = /[0-9]/.test(value);
        const onlyAlphaNumeric = /^[a-zA-Z0-9]+$/.test(value);
        return containsAlphabet && containsNumber && onlyAlphaNumeric;
      }
    },
    operatorPwd: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(30),
      alphabetValid: function(value) {
        const containsAlphabetUpper = /[A-Z]/.test(value);
        const containsAlphabetLower = /[a-z]/.test(value);
        return containsAlphabetUpper && containsAlphabetLower;
      },
      noSpace: function(value) {
        const noSpaceIn = /^\S*$/.test(value)
        return noSpaceIn
      },
      numberValid: function(value) {
        const containsNumber = /[0-9]/.test(value);
        return containsNumber;
      },
      symbolValid: function(value) {
        const containSpecialCharacters =/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value);
        return containSpecialCharacters;
      }
    },
    operatorWhiteLabel: {
      required
    }
  },
  computed: {},
  mounted() {
    var whiteLabel = config.whiteLabel
    if(whiteLabel != null) {
      var splitWhiteLabel = whiteLabel.split(',')
      for(var i = 0; i < splitWhiteLabel.length; i++) {
        this.wLList.push(splitWhiteLabel[i])
      }
    }
  },
  methods: {
    toggleShow(evt) {
      evt.preventDefault();
      this.showPassword = !this.showPassword;
    },
    reset() {
      this.loading = false
      this.operatorId = ""
      this.operatorPwd = ""
      this.operatorWhiteLabel = "ROCKET"
      this.$v.$reset()
    },
    submit() {
      this.$v.$reset()
      this.$v.$touch()
      if (this.$v.$invalid)
        return false;

      this.cartAgent();
    },
    cartAgent() {
      let url = config.cartOperatorAddUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        cart_id: this.cartId,
        operator_id: this.operatorId.toLowerCase(),
        operator_password: this.operatorPwd,
        white_label: this.operatorWhiteLabel
      }

      this.loading = true
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.$swal({
                  title: this.$t("message.operatorAccCreatedSuccessful"),
                  html: "<div>" + this.$t("ui.bo_url") + ": </div>" +
                        "<div id='text-to-copy'><a href='https://" + response.data.dt[0].domain_name + "' target='_blank'>" + response.data.dt[0].domain_name + "</a></div>" +
                        "<div id='copy-status' class='position-absolute font-weight-bold' style='display:none;padding-top:7px;font-size:13px;left:-96px;right:0px'> " + this.$t("ui.copied") + "!</div>",
                  type: 'success',
                  showCancelButton: true,
                  confirmButtonText: "<div id='copy_text'>" + this.$t("ui.copy") + "</div>",
                  cancelButtonText: this.$t("ui.ok"),
                  cancelButtonColor: "#3085d6",
                  confirmButtonColor: "#4aa9cf",
                  allowOutsideClick: false,
                  preConfirm: () => {
                    var string = "Operator ID: " + this.operatorId +
                                  "\nOperator Password: " + this.operatorPwd +
                                  "\nBack Office Url: " + response.data.dt[0].domain_name
                    var element = $('<textarea>').appendTo('body').val(string).select();
                    document.execCommand('copy');
                    element.remove();
                    document.getElementById('copy-status').style.display = 'block';
                    setTimeout(() => {
                      document.getElementById('copy-status').style.display = 'none';
                    }, 2000);
                    return false;
                  },
                })
                .then((isConfirm) => {
                  if (isConfirm.value) {

                  } else if (
                    this.$router.push('/system/dashboard')
                  )
                  this.reset()
                })

              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    }
  }
}
</script>